import { Core } from "./core";

export interface IFilter {
    TypeName: string;
    And(filter: IFilter | Array<IFilter>): IFilter;
    Or(filter: IFilter | Array<IFilter>): IFilter;
    Not(): IFilter;
}
export enum enmConditionalOperators {
    Equal = 0,
    NotEqual = 1,
    Less = 2,
    Greater = 3,
    StartsLike = 4,
    EndsLike = 5,
    Like = 6,
    LessOrEqual = 7,
    GreaterOrEqual = 8,
    NotLike = 9,
    NullOrEmpty = 10,
    NotNullOrEmpty = 11
}
export enum enmLogicalOperators {
    And,
    Or,
    Not
}
export class Filter implements IFilter {
    TypeName: string;
    constructor(typename: string) {
        this.TypeName = typename;
    }
    And(filter: IFilter | Array<IFilter>): IFilter {
        if (this instanceof AndFilter || this instanceof OrFilter) {
            if (filter instanceof Array) {
                let collection = filter;
                collection.push(this);
                return new AndFilter(collection);
            }
            return new AndFilter([this, filter]);
        }
        else {
            if (filter instanceof Array) {
                let collection = filter;
                collection.push(this);
                return new AndFilter(collection);
            }
            return new AndFilter([this, filter]);
        }
    }
    Or(filter: IFilter | Array<IFilter>): IFilter {
        if (this instanceof OrFilter || this instanceof AndFilter) {
            if (filter instanceof Array) {
                let collection = filter;
                collection.push(this);
                return new OrFilter(collection);
            }
            return new OrFilter([this, filter]);
        }
        else {
            if (filter instanceof Array) {
                let collection = filter;
                collection.push(this);
                return new OrFilter(collection);
            }
            return new OrFilter([this, filter]);
        }
    }
    Not(): IFilter {
        return new NotFilter(this);
    }
}
export class ComparisonFilter extends Filter {
    Property: string;
    Operator: enmConditionalOperators;
    Value: any;
    constructor(propertyName: string, op: enmConditionalOperators, value: any) {
        super("ComparisonFilter");
        this.Operator = op;
        this.Property = propertyName;
        this.Value = value;
    }
    static Create<T>(propertySelector: (obj: T) => void, op: enmConditionalOperators, value: any): ComparisonFilter {
        let propName = Core.getPropertyName(propertySelector);
        return new ComparisonFilter(propName, op, value);
    }
    static Equal<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.Equal, value);
    }
    static NotEqual<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.NotEqual, value);
    }
    static Greater<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.Greater, value);
    }
    static GreaterOrEqual<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.GreaterOrEqual, value);
    }
    static Less<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.Less, value);
    }
    static LessOrEqual<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.LessOrEqual, value);
    }
    static Like<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.Like, value);
    }
    static StartsLike<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.StartsLike, value);
    }
    static EndsLike<T>(propertySelector: (obj: T) => void, value: any): ComparisonFilter {
        return ComparisonFilter.Create<T>(propertySelector, enmConditionalOperators.EndsLike, value);
    }
}
export class InFilter extends Filter {
    Property: string;
    Values: Array<any>;
    constructor(propertyName: string, values: Array<any>) {
        super("InFilter");
        this.Property = propertyName;
        this.Values = values;
    }
    static Create<T>(propertySelector: (obj: T) => void, values: Array<any>): InFilter {
        let propName = Core.getPropertyName(propertySelector);
        return new InFilter(propName, values);
    }
}
export class AndFilter extends Filter {
    Collection: Array<IFilter>;
    constructor(collection: Array<IFilter>) {
        super("AndFilter");
        this.Collection = collection;
    }
}
export class OrFilter extends Filter {
    Collection: Array<IFilter>;
    constructor(collection: Array<IFilter>) {
        super("OrFilter");
        this.Collection = collection;
    }
}
export class NotFilter extends Filter {
    Filter: IFilter;
    constructor(filter: IFilter) {
        super("NotFilter");
        this.Filter = filter;
    }
}
export class IsNullFilter extends Filter {
    Property: string;
    constructor(propertyName: string) {
        super("IsNullFilter");
        this.Property = propertyName;
    }
    static Create<T>(propertySelector: (obj: T) => void): IsNullFilter {
        let propName = Core.getPropertyName(propertySelector);
        return new IsNullFilter(propName);
    }
}
export class TrueFilter extends Filter {
    constructor() {
        super("TrueFilter");
    }
} 
export class FalseFilter extends Filter {
    constructor() {
        super("FalseFilter");
    }
} 